'use client';

import React, { useContext, useEffect, useState } from 'react';
import { ArrowLongLeftIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';
import classNames from 'classnames';
import { GateStyleContext } from './GateStyleContext';
import { getLinkStyle } from '../selectors/Link/Link';

const messages = {
	en: {
		heading: 'The job offer has been closed.',
		backToHomepage: 'Back to homepage',
	},
	sk: {
		heading: 'Pracovná ponuka bola uzavretá.',
		backToHomepage: 'Naspäť na domovskú stránku',
	},
	cs: {
		heading: 'Pracovní nabídka byla uzavřena.',
		backToHomepage: 'Zpět na domovskou stránku',
	},
	de: {
		heading: 'Das Stellenangebot wurde geschlossen.',
		backToHomepage: 'Zurück zur Startseite',
	},
	hu: {
		heading: 'Az állásajánlat lezárult.',
		backToHomepage: 'Vissza a honlapra',
	},
};

export default function RenderError() {
	const { dark, settings, ...button } = useContext(GateStyleContext);

	const [language, setLanguage] = useState('en');

	useEffect(() => {
		const locale = navigator?.language?.substring(0, 2);
		if (messages[locale]) {
			setLanguage(locale);
		}
	}, []);

	return (
		<div className="p-4">
			<div className={classNames(dark ? 'text-white' : 'text-gray-900', 'text-center')}>
				<div className="ml-3 space-y-6">
					<h3 className="text-lg font-medium">
						{messages[language].heading}
					</h3>
					<div className="mt-2 text-base">
						<Link href="/" className="inline-flex gap-2" style={getLinkStyle(button, settings)}>
							<ArrowLongLeftIcon className="h-5 w-5" />
							{messages[language].backToHomepage}
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
}
